export default "__VITE_ASSET__4abf4afd__"